import styled from 'styled-components';

export const MockupDataInputContainer = styled.div`
  width: 100%;
  justify-content: center;
`;

export const MockupRowContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  h5 {
    all: unset;
  }

  .hefesto-keyvalueitem {
    margin-bottom: 1rem;
  }
`;

export const IncreaseDecreaseContainer = styled.div`
  width: 7.5rem;
`;

export const SecondaryInputContainer = styled.div`
  display: flex;
  margin-top: 1rem;
  width: 50%;
  align-items: center;
  gap: 1rem;
`;

export const Subtitle = styled.span`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
  margin-bottom: 1rem;
`;

export const Description = styled.span`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const OptionsContainer = styled.div`
  display: flex;
  gap: 0.4rem;
  flex-direction: column;

  > .hefesto-checkbox {
    margin-left: 0.3rem;
  }
`;
